import { getRootUrl } from '@utils/urlHelpers.util';
import { CloudImageRowProps } from '@components/CloudImageRow';

export const SLIDE_SPEED = 3;

export const SECTION_ID = 'RegistryShopRegistrySection';

export const VENDOR_IMAGES: CloudImageRowProps = [
  {
    title: 'KitchenAid',
    link: getRootUrl('/shop/brand/kitchenaid'),
    image: {
      url: 'registry-v2/ab-test/brands/kitchenaid.svg',
    },
    sm: {
      width: 236,
      height: 23,
    },
    belowSm: {
      width: 146,
      height: 14,
    },
  },
  {
    title: 'Le Creuset',
    link: getRootUrl('/shop/brand/le-creuset'),
    image: {
      url: 'registry-v2/ab-test/brands/le-creuset.svg',
    },
    sm: {
      width: 223,
      height: 37,
    },
    belowSm: {
      width: 138,
      height: 23,
    },
  },
  {
    title: 'Vitamix',
    link: getRootUrl('/shop/brand/vitamix'),
    image: {
      url: 'registry-v2/ab-test/brands/vitamix.svg',
    },
    sm: {
      width: 165,
      height: 36,
    },
    belowSm: {
      width: 102,
      height: 22,
    },
  },
  {
    title: 'Fellow',
    link: getRootUrl('/shop/brand/fellow'),
    image: {
      url: 'registry-v2/ab-test/brands/fellow.svg',
    },
    sm: {
      width: 160,
      height: 33,
    },
    belowSm: {
      width: 99,
      height: 20,
    },
  },
  {
    title: 'Riedel',
    link: getRootUrl('/shop/brand/riedel'),
    image: {
      url: 'registry-v2/ab-test/brands/riedel.svg',
    },
    sm: {
      width: 102,
      height: 40,
    },
    belowSm: {
      width: 63,
      height: 24,
    },
  },
  {
    title: 'Fable',
    link: getRootUrl('/shop/brand/fable'),
    image: {
      url: 'registry-v2/ab-test/brands/fable.svg',
    },
    sm: {
      width: 91,
      height: 31,
    },
    belowSm: {
      width: 56,
      height: 19,
    },
  },
  {
    title: 'Cuisinart',
    link: getRootUrl('/shop/brand/cuisinart'),
    image: {
      url: 'registry-v2/ab-test/brands/cuisinart.svg',
    },
    sm: {
      width: 170,
      height: 29,
    },
    belowSm: {
      width: 106,
      height: 18,
    },
  },
  {
    title: 'Airbnb',
    link: getRootUrl('/shop/brand/airbnb'),
    image: {
      url: 'registry-v2/ab-test/brands/airbnb.svg',
    },
    sm: {
      width: 144,
      height: 45,
    },
    belowSm: {
      width: 89,
      height: 28,
    },
  },
  {
    title: 'YETI',
    link: getRootUrl('/shop/brand/yeti'),
    image: {
      url: 'registry-v2/ab-test/brands/yeti.svg',
    },
    sm: {
      width: 108,
      height: 30,
    },
    belowSm: {
      width: 67,
      height: 18,
    },
  },
  {
    title: 'iRobot',
    link: getRootUrl('/shop/brand/irobot'),
    image: {
      url: 'registry-v2/ab-test/brands/irobot 1.svg',
    },
    sm: {
      width: 140,
      height: 32,
    },
    belowSm: {
      width: 87,
      height: 19,
    },
  },
  {
    title: 'GreenPan',
    link: getRootUrl('/shop/brand/greenpan'),
    image: {
      url: 'registry-v2/ab-test/brands/greenpan.svg',
    },
    sm: {
      width: 108,
      height: 56,
    },
    belowSm: {
      width: 66,
      height: 34,
    },
  },
  {
    title: 'Ooni',
    link: getRootUrl('/shop/brand/ooni'),
    image: {
      url: 'registry-v2/ab-test/brands/ooni-logo.svg',
    },
    sm: {
      width: 108,
      height: 56,
    },
    belowSm: {
      width: 66,
      height: 34,
    },
  },
  {
    title: 'Breville',
    link: getRootUrl('/shop/brand/breville'),
    image: {
      url: 'registry-v2/ab-test/brands/breville.svg',
    },
    sm: {
      width: 140,
      height: 32,
    },
    belowSm: {
      width: 75,
      height: 19,
    },
  },
  {
    title: 'Samsonite',
    link: getRootUrl('/shop/brand/samsonite'),
    image: {
      url: 'registry-v2/ab-test/brands/samsonite.svg',
    },
    sm: {
      width: 140,
      height: 32,
    },
    belowSm: {
      width: 115,
      height: 19,
    },
  },
  {
    title: 'Shark',
    link: getRootUrl('/shop/brand/shark'),
    image: {
      url: 'registry-v2/ab-test/brands/shark.svg',
    },
    sm: {
      width: 140,
      height: 32,
    },
    belowSm: {
      width: 73,
      height: 19,
    },
  },
];
